<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
            <!-- <label style="margin-left: 20px;">All Designs : </label>         
            
             <hr style="height:30px"> -->
          <div class="accordion" role="tablist">
            <b-card no-body class="mb-1" v-for="(list, index) in brandData" :key="list.brand_type">
              <b-card-header header-tag="header" class="p-1" role="tab" v-bind:id="'collapse' + index" @click="displayDashboardData(list.brand_type)">
                <b-button block  v-b-toggle="'accordion-' + list.brand_type" style="background-color:#f8f8ff">
                  <b-row class="col-md-12">
                    <b-col class="col-md-4" style="text-align: left;">
                      <!-- {{list.brand_id}} -->
                    </b-col>
                        <b-col class="col-md-4" style="text-align: center;">
                        <b v-b-tooltip.hover title="Brand Type"  >{{list.brand_type}}</b>

                    </b-col>
                    <!-- <b-col class="col-md-4" style="text-align: right;">
                      <b-badge v-if="list.pending_count != null" style="font-size: 12px;" variant="danger" v-b-tooltip.hover title="Total Pending For Approval">{{list.pending_count}}</b-badge>
                      <b-badge v-if="list.pending_count == null" style="font-size: 12px;" variant="danger" v-b-tooltip.hover title="Total Pending For Approval">0</b-badge>
                    </b-col> -->
                  </b-row>
                </b-button>
              </b-card-header>     
            
              <b-collapse class="'accordion-' + list.brand_type" v-bind:id="'accordion-' + list.brand_type" accordion="my-accordion" role="tabpanel">
                <b-card-body style="background-color:#f8f8ff">
                  <label style="padding-top: 10px!important; margin-left: 20px;">Available Brands :</label>                
                    <b-row class="boxto"> 
                      <!-- {{ resultData }} -->
                        <b-col sm="6" lg="2" class="pointer" v-for="data in resultData">
                            
                              <b-card no-body class="bg-aqua" style="height:125px !important">
                                <!-- {{ data.brand_title  }} -->
                                <router-link  :to="'/dashboard/' +data.brand_id +','+data.brand_Type" v-if="data.brand_title != 'Accessories'">
                                    <b-card-body class="pb-0">          
                                    <h4 class="mb-0 display-5 text-center countcolor" v-b-tooltip.hover title="Click to See Dashboard" style="margin-top: 10%;" v-bind="data.brand_id">{{data.brand_title}}</h4>
                                    <!-- <p class="text-center countcolor"  v-b-tooltip.hover title="Designs Pending For Approval">Designs Pending For Approval</p> -->
                                    </b-card-body> 
                                </router-link> 
                                <div v-if="data.brand_title == 'Accessories'" @click="showmodalForAccessories()">
                                  <b-card-body class="pb-0">          
                                    <h4 class="mb-0 display-5 text-center countcolor" v-b-tooltip.hover title="Click to See Dashboard" style="margin-top: 10%;" v-bind="data.brand_id">{{data.brand_title}}</h4>
                                    <!-- <p class="text-center countcolor"  v-b-tooltip.hover title="Designs Pending For Approval">Designs Pending For Approval</p> -->
                                    </b-card-body> 
                                </div>
                                <br>
                                <router-link :to="'/style_list/' + 'Designs_Pending_For_Approval'+ ',' + data.brand_id +','+data.brand_Type"  v-if="data.brand_title != 'Accessories'">
                                    <b-card-body class="pb-0" style="text-align:center;">
                                              
                                    <span v-if="data.pending_count != null" style="color: aliceblue;font-size: 30px;" v-b-tooltip.hover title="Click to See Pending Listing">{{data.pending_count}}</span>
                                    <span v-if="data.pending_count == null" style="color: aliceblue;font-size: 30px;" v-b-tooltip.hover title="Click to See Pending Listing">{{0}}</span>
                                  </b-card-body>
                                </router-link> 
                                <div v-if="data.brand_title == 'Accessories'" @click="showmodalForAccessories()">
                                  <b-card-body class="pb-0" style="text-align:center;">
                                              
                                    <span v-if="pendingCountSum != 0" style="color: aliceblue;font-size: 30px;" v-b-tooltip.hover title="Click to See Pending Listing">{{pendingCountSum}}</span>
                                    <span v-if="pendingCountSum == 0" style="color: aliceblue;font-size: 30px;" v-b-tooltip.hover title="Click to See Pending Listing">{{0}}</span>
                                  </b-card-body>
                                </div>
                              </b-card>
                            
                        </b-col>
                        
                    </b-row>

                    <!--  <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text> -->
                      <!-- <b-card-text>{{ text }}</b-card-text> -->
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>



          <!-- STATIC DATA -->
          <div class="accordion newaccc" role="tablist">
            <b-card no-body class="">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="light">
                  <span class="cookies" style="margin-left:-20px;"><b>kookie kids</b></span>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Available Brands : No data</b-card-text>
                  
                </b-card-body>
              </b-collapse>
            </b-card>

          </div>

          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal size="lg"
        title="Brand For Accessories"
        v-model="modalForAccessories"
        @ok="modalForAccessories = false">
        <!-- {{ this.filteredObjects }} -->
        <b-row>
          <b-col md="6" lg="4" class="pointer" v-for="accdata in filteredObjects" :key="accdata.brand_id">
            <b-card no-body class="bg-aqua" style="height:125px !important">
              
              <router-link :to="'/dashboard/' + accdata.brand_id + ',' + accdata.brand_Type" v-if="accdata.brand_title != 'Accessories'">
                <b-card-body class="pb-0">
                  <h4 class="mb-0 display-5 text-center countcolor" v-b-tooltip.hover title="Click to See Dashboard" style="margin-top: 10%;" v-bind="accdata.brand_id">{{ accdata.brand_title }}</h4>
                </b-card-body>
              </router-link>

              <br>
              
              <router-link :to="'/style_list/' + 'Designs_Pending_For_Approval' + ',' + accdata.brand_id + ',' + accdata.brand_Type" v-if="accdata.brand_title != 'Accessories'">
                <b-card-body class="pb-0" style="text-align:center;">
                  <span v-if="accdata.pending_count != null" style="color: aliceblue; font-size: 30px;" v-b-tooltip.hover title="Click to See Pending Listing">{{ accdata.pending_count }}</span>
                  <span v-if="accdata.pending_count == null" style="color: aliceblue; font-size: 30px;" v-b-tooltip.hover title="Click to See Pending Listing">{{ 0 }}</span>
                </b-card-body>
              </router-link>
            
            </b-card>
          </b-col>
        </b-row>

    </b-modal>
  </div>
</div>
 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
 import Router from 'vue-router'
const axios = require('axios');
export default {
  name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
      a:-1,

      resultData:[],
      brandData:[],
      Designs_Pending_For_Approval: 0,
      Designs_Approved: 0,
      Designs_Feedback: 0,
      Designs_Rejected: 0,
      breadcrumbs: [{
        text: 'Dashboard',
        active: true
      
      }],
      filteredObjects:[],
      newBrandObjects:[],
      pendingCountSum:0,
      modalForAccessories: false
    }
  },
 
  created: function () {
    this.getBrandtype();
    // this.displayDashboardData();
  },

  methods: {
    getBrandtype:function(){
        var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData);
           const Obj={}
            axios.post(`${CONSTANTS.API_URL}/getBrandTypeAndCount`,Obj)
                .then(response => {
                  // document.getElementById('overlay').style.display="none";
                 var result = response.data;
                  if (result.returnmsg === 'Successful') {
                    this.brandData = response.data.returnvalue;
                    console.log("brandData",this.brandData)
                    // this.displayDashboardData();

     
                  }
                  else{
                    this.brandData=[];

                  }   
          //}
        
        }) 
    },

    displayDashboardData: function (brandtype) {
        this.filteredObjects =[]
        this.pendingCountSum = ''
        document.getElementById('overlay').style.display="block";
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData);
            const Obj={
              brand_type:brandtype,
            }
            axios.post(`${CONSTANTS.API_URL}/brandlisting`,Obj)
                .then(response => {
                  document.getElementById('overlay').style.display="none";
                 var result = response.data;
                 
                  if (result.returnmsg === 'Successful') {
                    
                    if(response.data.returnvalue[0].brand_Type == 'clothing'){
                        this.newBrandObjects = [{
                          "brand_type": "Accessories",
                          "brand_id": '000000',
                          "brand_title": "Accessories",
                          "abvr": "ACC",
                          "assigned_brand_manager": "",
                          "pending_count": null,
                          "brand_Type": "clothing"
                      }]
                    }else{
                      this.newBrandObjects = [{
                          "brand_type": "Accessories",
                          "brand_id": '000000',
                          "brand_title": "Accessories",
                          "abvr": "ACC",
                          "assigned_brand_manager": "",
                          "pending_count": null,
                          "brand_Type": "footware"
                      }]

                    }

                // Append the new objects to the resultData array
                this.resultData = response.data.returnvalue.concat(this.newBrandObjects);

                console.log("this.resultData--------->", this.resultData); 
                const excludeBrandIds = [10002, 10003, 10004]   
                // const excludeBrandIds = [1006469, 1004078, 1006125];
                  this.pendingCountSum = 0; 

                  this.resultData = this.resultData.filter((item) => {
                      if (excludeBrandIds.includes(item.brand_id)) {
                          this.filteredObjects.push(item);
                          if (item.pending_count !== null) {
                              const pendingCount = parseFloat(item.pending_count.trim()); 
                              if (!isNaN(pendingCount)) {
                                  this.pendingCountSum += pendingCount;
                                  console.log("Adding:", pendingCount, "New Sum:", this.pendingCountSum); 
                              } else {
                                  console.log("Invalid number:", item.pending_count);
                              }
                          }
                          return false; 
                      }
                      return true; 
                  });

                  console.log("Final Pending Count Sum:", this.pendingCountSum); // Debug: Show final sum


                  console.log("this.filteredObjthis.pendingCountSumects", this.pendingCountSum);
      
                  }
                  else{
                    this.resultData=[];
                    this.filteredObjects =[]
                    this.pendingCountSum = ''

                  }   
          //}
        
        })        
    },

    showmodalForAccessories(){
      this.modalForAccessories = true;
    }
    
  }
};

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
      width: 150px;
  height: 140px;
  margin-left: 20px;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
   width: 150px;
  height: 140px;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
     width: 150px;
  height: 140px;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
       width: 150px;
  height: 140px;
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  width: 150px;
  height: 140px;
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}

</style>